module.exports = __webpack_public_path__ + "static/media/Lounge.506450c0.webp";